import React, { useEffect, useState } from "react"
import { ClienteCard } from '../clientCard'
import { Loader } from "../../../generics/loader"
import { useIsFetching } from "@tanstack/react-query"
import { useDividas } from "../../../../context/DividasContext"
import { useModal } from "../../../../hooks/ModalContext"
import { useBoleto } from "../../../../context/BoletoContext"
import { QueueProps, useFilaTransbordo } from "../../../../context/FilaTransbordoContext"
import { useAuth } from "../../../../context/AuthContext"

interface FilaOperadorProps {
  data: any
  isSuccess: boolean
}

export const FilaOperador = ({ data, isSuccess }: FilaOperadorProps) => {
  const [clientSelected, setClientSelected] = useState(0);
  const { onClose, setModal } = useModal();
  const { getDividasGazin, devedor } = useDividas()
  const { boleto } = useBoleto()
  const { cookies } = useAuth()
  const { getDevedorFilaSelected, devedorFilaSelected, getQueue } = useFilaTransbordo()

  function verifySelected(id: number, id_queue: number) {
    return id_queue
  }


  async function inicioAtendimento(queue: QueueProps) {

    if (devedorFilaSelected && devedorFilaSelected?.chatData?.cpfDevedor && boleto?.url) {
      setModal('Para fazer essa aÃ§Ã£o finalize o atendimento corretamente!', 'Erro', false, true)
      return
    }

    if (queue.chatData.cpfDevedor !== devedor?.cpf_cnpj) {
      setClientSelected(verifySelected(clientSelected, Number(queue._id)))
      getDevedorFilaSelected(queue)
      onClose()
      //limpar tds os dados aqui e dps fazer td
      await getDividasGazin({ cpf_cnpj: queue.chatData.cpfDevedor, app: 'ACIONA_OPE', usuario: String(cookies?.user?.id_operador), });

    }
  }

  const isFetching = useIsFetching({ queryKey: ['transbordo-atendimento'] })

  useEffect(() => {
    if (isSuccess && data?.queue?.length > 0 && devedorFilaSelected?.chatData.cpfDevedor) {
      setClientSelected(Number(devedorFilaSelected._id))
      getQueue(data?.queue)
    }
  }, [isFetching])

  function mostrarFila() {
    return (isSuccess && data?.length > 0) && data?.map((queue: any) => {

      return (

        <div
          onDoubleClick={() => inicioAtendimento(queue)}
          className={` cursor-pointer hover:opacity-95 ${queue.chatData.ativo && 'hidden'}`}
          key={queue._id}
        >

          <ClienteCard
            nome={queue.name}
            hora_fila={queue.createdAt}
            text={
              "Transbordo"
            }
            isSelected={queue._id === devedorFilaSelected?._id}
            naoLido={queue.unread}
          />
        </div>
      )

    })
  }

  // console.log(fila)

  return (
    <div className="max-h-[30%] min-h-[30%] overflow-y-auto overflow-x-hidden pr-1  ">
      {
        isFetching || !isSuccess ? (<div className=" flex justify-center items-center  min-h-[3rem]  ">
          <Loader />
        </div>) : mostrarFila()
      }

    </div>
  )
}